import React from "react";
import {connect} from "react-redux";
import MyTheme from "../../Theme/Theme";
import {Button, StyleSheet, Text, TouchableOpacity, View} from "react-native";



class BoutonGenerale extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            isDark: false,
            theme : MyTheme.light
        }
        this.isActivate = this.props.isActivate;
        this.backgroundColor = this.props.backgroundColor;
        this.hasBorder = this.props.hasBorder;
        this.size = this.props.size;
        this.keepWhite = this.props.keepWhite;
        //this._getBackgroundColor = this._getBackgroundColor.bind(this);
    }

    _getBackgroundColor(){
        if(this.keepWhite){
            return "#fff";
        }
        if(this.backgroundColor == "gris"){
            return this.props.theme.colors.tertiary.black10.value
        }

        if(this.backgroundColor == "blanc"){
            return this.props.theme.colors.primary.White.value
        }

        if(this.isActivate){
            return this.props.theme.colors.primary.blue1.value
        }else{
            return this.props.theme.colors.primary.blue4.value
        }
    }

    _getTextColor(){
        if(this.backgroundColor == "blanc" || this.backgroundColor == "bleu"){
             return this.props.theme.colors.primary.blue1.value;
        }
         return "#fff";
    }

    render() {

        const styles = StyleSheet.create({
            bouton: {
                paddingVertical: (this.size == "large" ? 18:12 ),
                paddingHorizontal:14,
                backgroundColor : this._getBackgroundColor(),
                textAlign:"center",
                justifyContent:"center",
                alignItems:"center",
                //width:"50%",
                borderRadius:12,
                margin : 15,
                borderWidth : (this.hasBorder ? 1 : 0),
                borderColor :this._getTextColor(),
            },
            text: {
                color : this._getTextColor(),
                fontFamily  : this.props.theme.fonts.text,
                fontSize : 17,
            }
        });
        return (
            <TouchableOpacity onPress={this.props.onPress} style={{width:"100%"}}>
            <View style={[styles.bouton,this.props.style]}>
                <Text style={styles.text}>{this.props.title}</Text>
            </View>
            </TouchableOpacity>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(BoutonGenerale);
